export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:8080/api/v1';

// Static origin of the backend, for turning stored "/uploads/..." paths into absolute URLs.
export const BACKEND_ORIGIN = API_BASE_URL.replace(/\/api\/v1\/?$/, '');

export const ROLES = {
  ADMIN: 'ADMIN',
  APPROVER: 'APPROVER',
  TECHNICIAN: 'TECHNICIAN',
  CLIENT: 'CLIENT',
};

// Roles that can access the review queue (/review/**).
export const STAFF_ROLES = ['ADMIN', 'APPROVER'];

export const ACCOUNT_STATUS = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
  REJECTED: 'REJECTED',
  INACTIVE: 'INACTIVE',
};

export const BOOKING_STATUS = {
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
};

export const BOOKING_STATUS_LABELS = {
  AWAITING_APPROVAL: 'Awaiting approval',
  PENDING: 'Sent to technician',
  CONFIRMED: 'Confirmed',
  IN_PROGRESS: 'In progress',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  REJECTED: 'Rejected',
};

// Transitions the UI should offer, matching BookingService's server-side rules.
export const TECHNICIAN_BOOKING_ACTIONS = {
  PENDING: ['CONFIRMED', 'REJECTED'],
  CONFIRMED: ['IN_PROGRESS', 'CANCELLED'],
  IN_PROGRESS: ['COMPLETED'],
};

export const CLIENT_BOOKING_ACTIONS = {
  AWAITING_APPROVAL: ['CANCELLED'],
  PENDING: ['CANCELLED'],
  CONFIRMED: ['CANCELLED'],
};

export const DEFAULT_PAGE_SIZE = 12;

export const SORT_OPTIONS = [
  { value: 'averageRating', label: 'Top rated' },
  { value: 'hourlyRate', label: 'Hourly rate' },
  { value: 'yearsOfExperience', label: 'Experience' },
  { value: 'createdAt', label: 'Newest' },
];
